import React__default from 'react';

const SizeContext = React__default.createContext(void 0);
const SizeContextProvider = ({
  children,
  size
}) => /* @__PURE__ */ React__default.createElement(SizeContext.Consumer, null, (originSize) => /* @__PURE__ */ React__default.createElement(SizeContext.Provider, {
  value: size || originSize
}, children));

export { SizeContext, SizeContextProvider };
